import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0cdddedb&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=0cdddedb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdddedb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cdddedb')) {
      api.createRecord('0cdddedb', component.options)
    } else {
      api.reload('0cdddedb', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0cdddedb&scoped=true&", function () {
      api.rerender('0cdddedb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/customers/contractDesignInfo/index.vue"
export default component.exports